// App.jsx — Entrega Já: Consulta de Prazos
import { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { citiesData } from "./citiesData";
// import logo from "./logo_2_color.png"  <- o arquivo nao veio no source map
// porque a variavel nunca e usada no JSX; o webpack descartou o import.
import "./App.css";
import Header from '../../components/HeaderCidades';
import Footer from "../../components/Footer";

// === CONFIG ===
const GOOGLE_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbycMyHDDLApLD8kP75bn5z7Dkjn4dCacmRdKJZvxhYsDl0BMArbrJGCQkrEIFxqRKeM/exec";
// Cole a URL do seu Google Apps Script publicado como Web App
// Exemplo: "https://script.google.com/macros/s/AKfycbx.../exec"

const PER_PAGE = 50;


const ROUTES = [
  { uf: "MA", name: "Maranhão", cls: "rt-ma", cities: 217, prazo: "6–17", dist: "2.299–3.594" },
  { uf: "PA", name: "Pará", cls: "rt-pa", cities: 113, prazo: "6–19", dist: "2.331–4.939" },
  { uf: "PI", name: "Piauí", cls: "rt-pi", cities: 224, prazo: "6–20", dist: "2.664–3.575" },
  { uf: "TO", name: "Tocantins", cls: "rt-to", cities: 139, prazo: "6–15", dist: "1.824–3.862" },
  { uf: "AP", name: "Macapá", cls: "rt-ap", cities: 1, prazo: "18–21", dist: "3.393" },
  { uf: "SP", name: "São Paulo", cls: "rt-sp", cities: 3, prazo: "3–5", dist: "101–447" },
];

const UF_OPTIONS = [
  { value: "", label: "Todos" },
  { value: "AP", label: "AP — Amapá" },
  { value: "MA", label: "MA — Maranhão" },
  { value: "PA", label: "PA — Pará" },
  { value: "PI", label: "PI — Piauí" },
  { value: "SP", label: "SP — São Paulo" },
  { value: "TO", label: "TO — Tocantins" },
];

// === HELPERS ===
function formatPhone(value) {
  let v = value.replace(/\D/g, "").slice(0, 11);
  if (v.length > 7) return `(${v.slice(0, 2)}) ${v.slice(2, 7)}-${v.slice(7)}`;
  if (v.length > 2) return `(${v.slice(0, 2)}) ${v.slice(2)}`;
  return v;
}

function formatCep(value) {
  let v = value.replace(/\D/g, "").slice(0, 8);
  if (v.length > 5) return `${v.slice(0, 5)}-${v.slice(5)}`;
  return v;
}

function searchCep(cepNum) {
  for (let i = 0; i < citiesData.length; i++) {
    const parts = citiesData[i][2].match(/(\d{5})-?(\d{3})\s*a\s*(\d{5})-?(\d{3})/);
    if (!parts) continue;
    const min = parseInt(parts[1] + parts[2], 10);
    const max = parseInt(parts[3] + parts[4], 10);
    if (cepNum >= min && cepNum <= max) return citiesData[i];
  }
  return null;
}

function getPrazoClass(prazo) {
  if (prazo <= 8) return "prazo-fast";
  if (prazo <= 13) return "prazo-mid";
  return "prazo-slow";
}

// === COMPONENTS ===

function HeaderConsulta() {
  return (
    <header className="header">
      <div className="header-inner">
        <div className="logo-area">
          <span className="header-badge">Consulta de Prazos</span>
        </div>
        <div className="header-stats">
          <div className="stat-pill"><span className="num">697</span><span className="lbl">Cidades</span></div>
          <div className="stat-pill"><span className="num">6</span><span className="lbl">Estados</span></div>
          <div className="stat-pill"><span className="num">GRU</span><span className="lbl">Origem</span></div>
        </div>
      </div>
    </header>
  );
}

function LeadGate({ onUnlock }) {
  const [form, setForm] = useState({ nome: "", empresa: "", whatsapp: "", email: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (field, value) => {
    if (field === "whatsapp") value = formatPhone(value);
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    const { nome, empresa, whatsapp, email } = form;
    if (!nome || !empresa || !whatsapp || !email) {
      setError("Preencha todos os campos.");
      return;
    }
    if (!email.includes("@") || !email.includes(".")) {
      setError("Informe um e-mail válido.");
      return;
    }
    if (whatsapp.replace(/\D/g, "").length < 10) {
      setError("Informe um WhatsApp válido com DDD.");
      return;
    }

    setError("");
    setLoading(true);

    const payload = {
      nome,
      empresa,
      whatsapp: whatsapp.replace(/\D/g, ""),
      email,
      data: new Date().toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo" }),
      origem: window.location.href,
    };

    if (GOOGLE_SCRIPT_URL) {
      try {
        await fetch(GOOGLE_SCRIPT_URL, {
          method: "POST",
          mode: "no-cors",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      } catch (e) {
        console.warn("Erro ao enviar:", e);
      }
    } else {
      console.log("Lead capturado (configure GOOGLE_SCRIPT_URL):", payload);
    }

    try {
      localStorage.setItem("ej_ok", "1");
      localStorage.setItem("ej_lead_nome", nome);
      localStorage.setItem("ej_lead", JSON.stringify(payload));
    } catch (e) {}

    setSuccess(true);
    setTimeout(() => onUnlock(), 1500);
  };

  return (
    <section className="gate-section anim">
      <div className="gate-card">
        <div className="gate-top">
          <h2>
            Consulte prazos de entrega para<br />
            <span className="hl">697 cidades em 6 estados</span>
          </h2>
          <p>Cadastre-se abaixo e tenha acesso completo à nossa ferramenta de consulta de prazos, distâncias e cobertura.</p>
          <div className="gate-features">
            <div className="gate-feat"><span className="ico">✓</span> Busca por CEP</div>
            <div className="gate-feat"><span className="ico">✓</span> Filtros por cidade e UF</div>
            <div className="gate-feat"><span className="ico">✓</span> Prazo e distância</div>
            <div className="gate-feat"><span className="ico">✓</span> Atualizado 2026</div>
          </div>
        </div>

        {!success ? (
          <div className="gate-form-area">
            <div className="gate-form-label">Preencha para liberar o acesso</div>
            <div className="lead-row">
              <label>Nome *</label>
              <input className="lead-input" type="text" placeholder="Seu nome completo" value={form.nome} onChange={(e) => handleChange("nome", e.target.value)} />
            </div>
            <div className="lead-row">
              <label>Empresa *</label>
              <input className="lead-input" type="text" placeholder="Nome da empresa" value={form.empresa} onChange={(e) => handleChange("empresa", e.target.value)} />
            </div>
            <div className="lead-row">
              <label>WhatsApp *</label>
              <input className="lead-input" type="tel" placeholder="(00) 00000-0000" value={form.whatsapp} onChange={(e) => handleChange("whatsapp", e.target.value)} />
            </div>
            <div className="lead-row">
              <label>E-mail *</label>
              <input className="lead-input" type="email" placeholder="seu@email.com" value={form.email} onChange={(e) => handleChange("email", e.target.value)} />
            </div>
            {error && <div className="lead-error" style={{ display: "block" }}>{error}</div>}
            <button className="lead-btn" onClick={handleSubmit} disabled={loading}>
              {loading ? "Enviando..." : "Liberar consulta por CEP"}
            </button>
          </div>
        ) : (
          <div className="lead-success" style={{ display: "block" }}>
            <div className="check-anim">✓</div>
            <h3>Acesso liberado!</h3>
            <p>A busca por CEP e todos os filtros já estão disponíveis.</p>
          </div>
        )}

        <div className="gate-bottom">
          <p>Seus dados são usados apenas para contato comercial.</p>
        </div>
      </div>
    </section>
  );
}

function RoutesSection() {
  return (
    <section className="routes-section anim">
      <div className="routes-title">Rotas frequentes — Origem: Guarulhos/SP</div>
      <div className="routes-grid">
        {ROUTES.map((r) => (
          <div key={r.uf} className={`route-card ${r.cls}`}>
            <div className="route-uf">{r.uf}</div>
            <div className="route-name">{r.name}</div>
            <div className="route-stat">
              <span>{r.cities}</span> {r.cities === 1 ? "cidade" : "cidades"}<br />
              <span>{r.prazo}</span> dias<br />
              <span>{r.dist}</span> km
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

function CepSearch() {
  const [cep, setCep] = useState("");
  const [result, setResult] = useState(null);
  const [searched, setSearched] = useState(false);

  const handleCepChange = (value) => {
    const formatted = formatCep(value);
    setCep(formatted);
    const digits = formatted.replace(/\D/g, "");
    if (digits.length === 8) {
      const num = parseInt(digits, 10);
      const match = searchCep(num);
      setResult(match);
      setSearched(true);
    } else {
      setSearched(false);
      setResult(null);
    }
  };

  return (
    <section className="cep-section anim" style={{ display: "block" }}>
      <div className="cep-card">
        <span className="cep-title">🔎 Busca por CEP</span>
        <input
          type="text"
          className="cep-input"
          placeholder="00000-000"
          maxLength={9}
          value={cep}
          onChange={(e) => handleCepChange(e.target.value)}
        />
        <div className="cep-result">
          {!searched && "Digite um CEP para localizar cidade, prazo e distância."}
          {searched && result && (
            <>
              <span className="match">✓ {result[1]}/{result[0]}</span>
              {" — Prazo: "}<strong>{result[5]} dias</strong>
              {" · Distância: "}<strong>{result[4].toLocaleString("pt-BR")} km</strong>
              {" · CEP: "}{result[2]}
            </>
          )}
          {searched && !result && (
            <span className="no-match">✗ CEP não encontrado na base.</span>
          )}
        </div>
      </div>
    </section>
  );
}

function SearchFilters({ searchCity, onSearchCity, filterUF, onFilterUF, filterPrazo, onFilterPrazo, prazoOptions }) {
  return (
    <section className="search-section anim">
      <div className="search-grid">
        <div className="field-group">
          <label>Buscar cidade</label>
          <svg className="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" />
          </svg>
          <input
            type="text"
            className="search-input"
            placeholder="Digite o nome da cidade..."
            value={searchCity}
            onChange={(e) => onSearchCity(e.target.value)}
          />
        </div>
        <div className="field-group">
          <label>Estado (UF)</label>
          <select className="search-input" value={filterUF} onChange={(e) => onFilterUF(e.target.value)}>
            {UF_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        </div>
        <div className="field-group">
          <label>Prazo (dias)</label>
          <select className="search-input" value={filterPrazo} onChange={(e) => onFilterPrazo(e.target.value)}>
            <option value="">Todos</option>
            {prazoOptions.map((p) => <option key={p} value={p}>{p} dias</option>)}
          </select>
        </div>
      </div>
    </section>
  );
}

function DataTable({ data, page, onPageChange, sortCol, sortAsc, onSort }) {
  const totalPages = Math.ceil(data.length / PER_PAGE);
  const start = (page - 1) * PER_PAGE;
  const slice = data.slice(start, start + PER_PAGE);

  const columns = [
    { key: 0, label: "UF", cls: "col-uf" },
    { key: 1, label: "Cidade", cls: "col-cidade" },
    { key: 2, label: "Faixa de CEP", cls: "col-cep" },
    { key: 4, label: "Distância", cls: "col-dist" },
    { key: 5, label: "Prazo", cls: "col-prazo" },
  ];

  const renderPagination = () => {
    if (totalPages <= 1) return null;
    const range = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) range.push(i);
    } else {
      range.push(1);
      if (page > 3) range.push("...");
      for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++) range.push(i);
      if (page < totalPages - 2) range.push("...");
      range.push(totalPages);
    }

    return (
      <div className="pagination">
        <button disabled={page <= 1} onClick={() => onPageChange(page - 1)}>‹</button>
        {range.map((p, i) =>
          p === "..." ? (
            <button key={`dots-${i}`} disabled>…</button>
          ) : (
            <button key={p} className={p === page ? "active" : ""} onClick={() => onPageChange(p)}>{p}</button>
          )
        )}
        <button disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>›</button>
      </div>
    );
  };

  return (
    <section className="table-section anim">
      <div className="table-header">
        <div className="results-count">
          Exibindo <span>{Math.min(start + PER_PAGE, data.length)}</span> de <span>{data.length}</span> resultados
        </div>
      </div>
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              {columns.map((col) => (
                <th
                  key={col.key}
                  className={`${col.cls}${sortCol === col.key ? " sorted" : ""}`}
                  onClick={() => onSort(col.key)}
                >
                  {col.label} <span className="sa">{sortCol === col.key ? (sortAsc ? "▲" : "▼") : "▲"}</span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {slice.map((r, i) => (
              <tr key={`${r[0]}-${r[1]}-${i}`}>
                <td className="col-uf"><span className={`uf-badge uf-${r[0]}`}>{r[0]}</span></td>
                <td className="col-cidade">{r[1]}</td>
                <td className="col-cep">{r[2]}</td>
                <td className="col-dist">{r[4].toLocaleString("pt-BR")} km</td>
                <td className="col-prazo"><span className={`prazo-badge ${getPrazoClass(r[5])}`}>{r[5]}d</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {renderPagination()}
    </section>
  );
}

function WhatsAppButton() {
  return (
    <a
      className="wpp-float"
      href="https://wa.me/551134750544?text=Ol%C3%A1%2C%20vim%20pela%20consulta%20de%20prazos%20e%20gostaria%20de%20falar%20com%20o%20comercial."
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className="wpp-tip">Fale com nosso comercial</span>
      <button className="wpp-btn" type="button" aria-label="WhatsApp">
        <span className="wpp-pulse"></span>
        <svg viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
        </svg>
      </button>
    </a>
  );
}

function Toast({ message, visible }) {
  return <div className={`toast${visible ? " show" : ""}`}>{message}</div>;
}

// === MAIN APP ===
export default function App() {
  const [unlocked, setUnlocked] = useState(false);
  const [searchCity, setSearchCity] = useState("");
  const [filterUF, setFilterUF] = useState("");
  const [filterPrazo, setFilterPrazo] = useState("");
  const [sortCol, setSortCol] = useState(1);
  const [sortAsc, setSortAsc] = useState(true);
  const [page, setPage] = useState(1);
  const [toast, setToast] = useState({ message: "", visible: false });
  const tableRef = useRef(null);

  // Check localStorage on mount
  useEffect(() => {
    try {
      if (localStorage.getItem("ej_ok") === "1") setUnlocked(true);
    } catch (e) {}
  }, []);

  // Unique prazo options
  const prazoOptions = useMemo(() => {
    const set = new Set(citiesData.map((r) => r[5]));
    return [...set].sort((a, b) => a - b);
  }, []);

  // Filtered + sorted data
  const filteredData = useMemo(() => {
    const q = searchCity.toUpperCase().trim();
    let result = citiesData.filter((r) => {
      if (q && !r[1].includes(q)) return false;
      if (filterUF && r[0] !== filterUF) return false;
      if (filterPrazo && r[5] !== +filterPrazo) return false;
      return true;
    });

    result.sort((a, b) => {
      const va = a[sortCol];
      const vb = b[sortCol];
      if (typeof va === "number") return sortAsc ? va - vb : vb - va;
      return sortAsc
        ? String(va).localeCompare(String(vb))
        : String(vb).localeCompare(String(va));
    });

    return result;
  }, [searchCity, filterUF, filterPrazo, sortCol, sortAsc]);

  // Reset page when filters change
  useEffect(() => { setPage(1); }, [searchCity, filterUF, filterPrazo]);

  const handleSort = useCallback((col) => {
    setSortCol((prev) => {
      if (prev === col) { setSortAsc((a) => !a); return prev; }
      setSortAsc(true);
      return col;
    });
    setPage(1);
  }, []);

  const handlePageChange = useCallback((p) => {
    setPage(p);
    tableRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  const showToast = useCallback((msg) => {
    setToast({ message: msg, visible: true });
    setTimeout(() => setToast((t) => ({ ...t, visible: false })), 3500);
  }, []);

  const handleUnlock = useCallback(() => {
    setUnlocked(true);
    showToast("Acesso liberado! Consulte qualquer CEP agora.");
  }, [showToast]);

  return (
    <div className="cidades-app">
      <Header />
      <HeaderConsulta />

      {!unlocked ? (
        <LeadGate onUnlock={handleUnlock} />
      ) : (
        <CepSearch />
      )}

      <RoutesSection />

      {/* Filtros */}
      <div className={!unlocked ? "gated" : ""} style={!unlocked ? { pointerEvents: "none" } : {}}>
        {!unlocked && (
          <div className="gate-msg">
            <div className="lock-icon">🔒</div>
            <h3>Filtros bloqueados</h3>
            <p>Preencha o cadastro acima para liberar.</p>
            <div className="arr">↑ Cadastre-se acima</div>
          </div>
        )}
        <SearchFilters
          searchCity={searchCity}
          onSearchCity={setSearchCity}
          filterUF={filterUF}
          onFilterUF={setFilterUF}
          filterPrazo={filterPrazo}
          onFilterPrazo={setFilterPrazo}
          prazoOptions={prazoOptions}
        />
      </div>

      {/* Tabela */}
      <div ref={tableRef} className={!unlocked ? "gated" : ""} style={!unlocked ? { pointerEvents: "none" } : {}}>
        {!unlocked && (
          <div className="gate-msg">
            <div className="lock-icon">🔒</div>
            <h3>Tabela bloqueada</h3>
            <p>Cadastre-se para consultar as 697 cidades.</p>
            <div className="arr">↑ Cadastre-se acima</div>
          </div>
        )}
        <DataTable
          data={filteredData}
          page={page}
          onPageChange={handlePageChange}
          sortCol={sortCol}
          sortAsc={sortAsc}
          onSort={handleSort}
        />
      </div>

      {/* <WhatsAppButton /> */}
      <Toast message={toast.message} visible={toast.visible} />
      <Footer />
    </div>
  );
}
